// src/components/ReceiptPrinter.js

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import './ReceiptPrinter.css';

export default function ReceiptPrinter() {
  const { billId } = useParams();
  const navigate    = useNavigate();
  const [bill, setBill]     = useState(null);
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(true);

  // Load the receipt data
  useEffect(() => {
    (async () => {
      try {

        const res = await api.get(`/print/${billId}`);
        // expects { bill: {...}, items: [...] }
        setBill(res.data.bill);
        setItems(res.data.items);
      } catch (err) {
        console.error('Error fetching receipt:', err);
        alert('Could not load receipt.');
        navigate(-1);
      } finally {
        setLoading(false);
      }
    })();
  }, [billId, navigate]);

  if (loading) {
    return <div className="loading">Loading receipt…</div>;
  }
  if (!bill) {
    return <div className="error">Receipt not found.</div>;
  }

  // compute totals
  const subtotal = items.reduce((sum, i) => sum + parseFloat(i.Subtotal), 0);
  const tax      = parseFloat(bill.Tax    || 0);
  const discount = parseFloat(bill.Discount || 0);
  const total    = bill.Status === 'paid'
    ? parseFloat(bill.Total)
    : subtotal + tax - discount;

  // Web‑print fallback
  const handleWebPrint = () => {
    window.print();
  };

  // Mobile: send to React Native wrapper
  const handleBluetoothPrint = () => {
    if (window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'PRINT_BILL', billId })
      );
    } else {
      handleWebPrint();
    }
  };

  return (
    <div className="receipt-container">
      <header className="receipt-header">
        <h1>{bill.HotelName || 'Hotel Viztech'}</h1>
        <div>Bill #: {bill.BillID}</div>
        <div>Date: {new Date(bill.CreatedAt).toLocaleString()}</div>
        <div>Status: {bill.Status}</div>
      </header>

      <table className="receipt-table">
        <thead>
          <tr>
            <th>Item</th><th>Qty</th><th>Price</th><th>Subtotal</th>
          </tr>
        </thead>
        <tbody>
           {items.map((it, idx) => (
              <tr key={it.BillItemID || idx}>
              <td>{it.ItemName}</td>
              <td>{it.Quantity}</td>
              <td>₹{parseFloat(it.UnitPrice).toFixed(2)}</td>
              <td>₹{parseFloat(it.Subtotal).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="receipt-summary">
        <div><span>Subtotal:</span><span>₹{subtotal.toFixed(2)}</span></div>
        {tax      > 0 && <div><span>Tax:</span><span>₹{tax.toFixed(2)}</span></div>}
        {discount > 0 && <div><span>Discount:</span><span>−₹{discount.toFixed(2)}</span></div>}
        <div className="total-line">
          <span>Total:</span><span>₹{total.toFixed(2)}</span>
        </div>
        <div><span>Payment:</span><span>{bill.PaymentMode}</span></div>
      </div>

      <div className="receipt-actions">
        <button className="btn-print-web"       onClick={handleWebPrint}>
          Print (Web)
        </button>
        <button className="btn-print-bluetooth" onClick={handleBluetoothPrint}>
          Bluetooth Print
        </button>
        <button className="btn-back" onClick={() => navigate(-1)}>
        ← Back
      </button>
      </div>
    </div>
  );
}
